import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { AdminUser } from '../../../models/Admin/AdminUsers';
import { RowItems } from '../../../models/TableProps';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Button, Menu, MenuItem } from '@mui/material';
import useProfileEditorDialog from '../../../hooks/useProfileEditorDialog';
import useAddToCompanyDialog from '../../../hooks/useAddToCompanyDialog';
import useConfirmDialog from '../../../hooks/dialogs/useConfirmDialog';
import useAdminApi from '../../../hooks/admin/useAdminApi';
import SnackbarUtils from '../../../utils/SnackbarUtils';

export const AdminUsersTableRow: React.FC<RowItems<AdminUser>> = (props) => {
    const { row, index } = props;
    const { t } = useTranslation('admin', {
        keyPrefix: 'USERS',
    });
    const labelId = `enhanced-table-checkbox-${index}`;
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const profileDialog = useProfileEditorDialog();
    const addToCompanyDialog = useAddToCompanyDialog();
    const confirmDialog = useConfirmDialog();
    const adminApi = useAdminApi();

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleProfileEditorClick = () => {
        handleClose();
        profileDialog.setIsAdmin(true);
        // profileDialog.setSelectedUser(row);
        profileDialog.showProfileEditor(true, row);
    };

    const handleShippingAddressesEditorClick = () => {
        handleClose();
        profileDialog.setSelectedUserId(row.id);
        profileDialog.showAdminAddressesEditor(true, 'shipping');
    };

    const handleBillingAddressesEditorClick = () => {
        handleClose();
        profileDialog.setSelectedUserId(row.id);
        profileDialog.showAdminAddressesEditor(true, 'billing');
    };

    const handleAddToCompanyClick = () => {
        handleClose();
        addToCompanyDialog.showDialog(
            true,
            row.bc_company_number.toString(),
            row.company,
            true
        );
    };

    const handleBlock = () => {
        adminApi
            .blockAllUser({
                bc_company_number: row.bc_company_number,
                active: 0,
            })
            .then((elem) => {
                SnackbarUtils.success('ADMIN_BLOCK_CONFIRM_SUCCESS');
                profileDialog.setProfileDialogClosedWithSuccess(true);
            });
    };

    const handleBlockAll = () => {
        handleClose();
        confirmDialog.showDialog({
            title: t('BLOCK_CONFIRM.TITLE'),
            content: t('BLOCK_CONFIRM.CONTENT', {
                company_name: row.company,
            }),
            confirmText: t('BLOCK_CONFIRM.CONFIRM'),
            cancelText: t('BLOCK_CONFIRM.CANCEL'),
            onConfirm: () => handleBlock(),
        });
    };

    return (
        <TableRow hover role="checkbox" tabIndex={-1}>
            <TableCell padding="checkbox"></TableCell>
            <TableCell padding="none" component="th" id={labelId} scope="row">
                {row.id}
            </TableCell>
            <TableCell>{row.bc_customer_no}</TableCell>
            <TableCell>{row.company}</TableCell>
            <TableCell>{row.email}</TableCell>
            <TableCell>
                {row.last_name} {row.first_name}
            </TableCell>
            <TableCell>{row.tax_number}</TableCell>
            <TableCell>{row.active ? 'Aktív' : 'Inaktív'}</TableCell>
            <TableCell align="right">
                <Button
                    id="basic-button"
                    aria-controls={open ? 'basic-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? 'true' : undefined}
                    onClick={handleClick}
                >
                    <MoreVertIcon sx={{ cursor: 'pointer' }} />
                </Button>
                <Menu
                    id="demo-positioned-menu"
                    aria-labelledby="demo-positioned-button"
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                    }}
                >
                    <MenuItem onClick={handleProfileEditorClick}>
                        {t('ACTIONS.PROFILE_EDIT')}
                    </MenuItem>
                    <MenuItem onClick={handleShippingAddressesEditorClick}>
                        {t('ACTIONS.ADDRESS_EDIT')}
                    </MenuItem>
                    <MenuItem onClick={handleBillingAddressesEditorClick}>
                        {t('ACTIONS.BILLING_EDIT')}
                    </MenuItem>
                    <MenuItem onClick={handleAddToCompanyClick}>
                        {t('ACTIONS.ADD_TO_COMPANY')}
                    </MenuItem>
                    <MenuItem onClick={handleBlockAll}>
                        {t('ACTIONS.BLOCK_ALL')}
                    </MenuItem>
                </Menu>
            </TableCell>
        </TableRow>
    );
};
